import { createStore, DeepPartial } from "redux";

import { rootReducer, StoreState } from "@redux/reducers/root";

export const setupStore = (initialState: DeepPartial<StoreState>) => createStore(rootReducer, initialState, window["__REDUX_DEVTOOLS_EXTENSION__"] && window["__REDUX_DEVTOOLS_EXTENSION__"]());
